





































































































































































































































































































































































































































































































































































































import {
  defineComponent,
  ref,
  onMounted,
  onUpdated,
  useContext,
  useRoute,
} from '@nuxtjs/composition-api';
import { SfNotification } from '@storefront-ui/vue';
import HydrogenCountrySelect from '~/components/HydrogenCountrySelect.vue';
import HydrogenNewsletter from '~/components/HydrogenNewsletter.vue';
import SfBreadcrumbs from '~/components/Sf/SfBreadcrumbs.vue';
import { useGtm, useHydrogenContactForm } from '~/composables';
import {
  getHydrogenCountryLabel,
  hydrogenCountryOptions,
} from '~/constants/hydrogenCountryOptions';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { Breadcrumb } from '~/modules/catalog/types';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { usePageStore } from '~/stores/page';
import { assign, join, map, trimEnd } from 'lodash-es';

type ProductRequest = {
  id: number;
  application: string;
  material: string;
  surfaceArea: string;
  thickness: string;
  porosity: string;
  productSize: string;
  quantity: string;
};

type ProductSizeSkuMap = Record<string, string>;
type ProductCatalog = Record<string, Record<string, Record<string, Record<string, Record<string, ProductSizeSkuMap>>>>>;

export default defineComponent({
  name: 'HydrogenGenerationRequestAQuote',
  components: {
    HydrogenCountrySelect,
    HydrogenNewsletter,
    SfBreadcrumbs,
    SfNotification,
    ValidationObserver,
    ValidationProvider,
  },
  setup() {
    const pageStore = usePageStore();
    const route = useRoute();
    const { eventPageLoad } = useGtm();
    const { localePath, app: { i18n, $config } } = useContext();
    const heroImage = '/hydrogen/request-a-quote-desktop-xxl.png';
    const pageTitle = i18n.t('Request a quote');
    const pageMetaData = ref({
      meta_title: join([pageTitle, $config.defaultMetaTitle], ' | '),
      meta_description: pageTitle,
      meta_keyword: pageTitle,
      pageTitle,
      metaDescription: pageTitle,
      pageUrl: trimEnd($config.baseUrl, '/') + route.value.path,
    });
    const leadSubSource = 'requestquote';
    const breadcrumbs = ref<Breadcrumb[]>([]);
    const maxProductRequests = 10;
    const productCatalog: ProductCatalog = {
      PEM: {
        'Titanium-Pt-Coated': {
          Normal: {
            '0,15 / 0,006': {
              '56': {
                '215x280mm': '9066903',
                '430x560mm': '9066892',
              },
            },
            '0,25 / 0,010': {
              '56': {
                '215x280mm': '9066904',
                '430x560mm': '9066905',
              },
            },
            '0,50 / 0,020': {
              '56': {
                '215x280mm': '9066906',
                '430x560mm': '9066907',
              },
            },
          },
        },
        Titanium: {
          Normal: {
            '0,15 / 0,006': {
              '56': {
                '215x290mm': '9066285',
                '430x580mm': '9066156',
              },
            },
            '0,20 / 0,008': {
              '67': {
                '215x290mm': '9066288',
                '430x580mm': '9066157',
              },
            },
            '0,25 / 0,010': {
              '56': {
                '215x290mm': '9066308',
                '430x580mm': '9065928',
              },
            },
            '0,35 / 0,014': {
              '68': {
                '215x290mm': '9066343',
                '430x580mm': '9066164',
              },
            },
            '0,50 / 0,020': {
              '56': {
                '215x290mm': '9066167',
                '430x580mm': '9066350',
              },
            },
            '0,75 / 0,030': {
              '70': {
                '215x290mm': '9066351',
                '430x580': '9066169',
              },
            },
            '1,00 / 0,039': {
              '56': {
                '215x290mm': '9066354',
                '430x580mm': '9065929',
              },
            },
          },
        },
      },
      AEM: {
        'Stainless Steel': {
          Normal: {
            '0,15 / 0,006': {
              '74': {
                '200x297mm': '9065665',
                '400x580mm': '9065666',
              },
            },
            '1,00 / 0,039': {
              '85': {
                '200x297mm': '9065671',
                '400x580mm': '9065672',
              },
            },
          },
          Medium: {
            '0,50 / 0,020': {
              '82': {
                '200x297mm': '9065669',
                '400x580mm': '9065670',
              },
            },
          },
          High: {
            '0,20 / 0,008': {
              '81': {
                '200x297mm': '9065652',
                '400x580mm': '9065664',
              },
            },
            '0,26 / 0,010': {
              '71': {
                '200x297mm': '9065477',
                '400x580mm': '9065478',
              },
            },
            '0,30 / 0,012': {
              '78': {
                '200x297mm': '9065667',
                '400x580mm': '9065668',
              },
            },
            '0,41 / 0,016': {
              '62': {
                '200x297mm': '9065710',
                '400x580mm': '9065711',
              },
            },
          },
        },
        'Nickel and Alloys': {
          Normal: {
            '0,10 / 0,004': {
              '66': {
                '215x290mm': '9062794',
                '430x580mm': '9065194',
              },
            },
            '0,20 / 0,008': {
              '83': {
                '215x290mm': '9062792',
                '430x580mm': '9065193',
              },
            },
            '0,25 / 0,010': {
              '60': {
                '215x290mm': '9062799',
                '430x580mm': '9065196',
              },
            },
            '0,50 / 0,020': {
              '66': {
                '215x290mm': '9062804',
                '430x580mm': '9065198',
              },
              '80': {
                '215x290mm': '9062796',
                '430x580mm': '9065195',
              },
            },
            '1,00 / 0,039': {
              '83': {
                '215x290mm': '9062802',
                '430x580mm': '9065197',
              },
            },
          },
          Medium: {
            '0,60 / 0,024': {
              '79': {
                '210x297mm': '9065718',
                '430x580mm': '9065719',
              },
            },
          },
          High: {
            '0,30 / 0,012': {
              '78': {
                '210x297mm': '9065712',
                '430x580mm': '9065713',
              },
            },
            '0,50 / 0,020': {
              '82 (Nickel HR)': {
                '210x297mm': '9065714',
                '430x580mm': '9065715',
              },
              '82 (Inconel)': {
                '210x297mm': '9065716',
                '430x580mm': '9065717',
              },
            },
          },
        },
      },
    };
    const getInitialProductRequest = (id = Date.now()): ProductRequest => ({
      id,
      application: '',
      material: '',
      surfaceArea: '',
      thickness: '',
      porosity: '',
      productSize: '',
      quantity: '',
    });
    const productRequests = ref<ProductRequest[]>([
      getInitialProductRequest(1),
    ]);
    const resetProductRequests = () => {
      productRequests.value = [getInitialProductRequest(1)];
    };
    const addProductRequest = () => {
      if (productRequests.value.length >= maxProductRequests) {
        return;
      }

      productRequests.value.push(getInitialProductRequest(Date.now()));
    };
    const removeProductRequest = (index: number) => {
      productRequests.value.splice(index, 1);
      if (productRequests.value.length === 0) {
        resetProductRequests();
      }
    };
    const getMaterialOptions = (application: string) => (
      application && productCatalog[application] ? Object.keys(productCatalog[application]) : []
    );
    const getSurfaceAreaOptions = (application: string, material: string) => (
      application && material && productCatalog[application]?.[material] ? Object.keys(productCatalog[application][material]) : []
    );
    const getThicknessOptions = (application: string, material: string, surfaceArea: string) => (
      application && material && surfaceArea && productCatalog[application]?.[material]?.[surfaceArea]
        ? Object.keys(productCatalog[application][material][surfaceArea])
        : []
    );
    const getPorosityOptions = (application: string, material: string, surfaceArea: string, thickness: string) => (
      application && material && surfaceArea && thickness && productCatalog[application]?.[material]?.[surfaceArea]?.[thickness]
        ? Object.keys(productCatalog[application][material][surfaceArea][thickness])
        : []
    );
    const getProductSizeOptions = (application: string, material: string, surfaceArea: string, thickness: string, porosity: string) => (
      application && material && surfaceArea && thickness && porosity
      && productCatalog[application]?.[material]?.[surfaceArea]?.[thickness]?.[porosity]
        ? Object.keys(productCatalog[application][material][surfaceArea][thickness][porosity])
        : []
    );
    const getProductSku = (product: ProductRequest) => (
      productCatalog[product.application]?.[product.material]?.[product.surfaceArea]?.[product.thickness]?.[product.porosity]?.[product.productSize] || ''
    );
    const buildHydrogenLeadProducts = () => {
      if (!productRequests.value.length) {
        return undefined;
      }

      const products = productRequests.value.map((product) => {
        const sku = getProductSku(product);
        const isComplete = Boolean(
          product.quantity
          && product.surfaceArea
          && product.application
          && product.material
          && product.thickness
          && product.productSize
          && product.porosity
          && sku
        );

        if (!isComplete) {
          return null;
        }

        return {
          quantity: String(product.quantity),
          surfaceArea: product.surfaceArea,
          application: product.application,
          material: product.material,
          thickness: product.thickness,
          productSize: product.productSize,
          porosityPercentage: product.porosity,
          sku,
        };
      });

      return products.every(Boolean) ? products : undefined;
    };
    const onProductApplicationChange = (product: ProductRequest) => {
      product.material = '';
      product.surfaceArea = '';
      product.thickness = '';
      product.porosity = '';
      product.productSize = '';
    };
    const onProductMaterialChange = (product: ProductRequest) => {
      product.surfaceArea = '';
      product.thickness = '';
      product.porosity = '';
      product.productSize = '';
    };
    const onProductSurfaceAreaChange = (product: ProductRequest) => {
      product.thickness = '';
      product.porosity = '';
      product.productSize = '';
    };
    const onProductThicknessChange = (product: ProductRequest) => {
      product.porosity = '';
      product.productSize = '';
    };
    const onProductPorosityChange = (product: ProductRequest) => {
      product.productSize = '';
    };
    const buildProductInformation = () => join(productRequests.value.map((product, index) => {
      const productParts = [
        `${i18n.t('Product request')}: ${index + 1}`,
        `${i18n.t('Application')}: ${product.application}`,
        product.material ? `${i18n.t('Material')}: ${product.material}` : '',
        product.surfaceArea ? `${i18n.t('Surface area')}: ${product.surfaceArea}` : '',
        product.thickness ? `${i18n.t('Thickness')}: ${product.thickness}` : '',
        product.porosity ? `${i18n.t('Porosity')}: ${product.porosity}` : '',
        product.productSize ? `${i18n.t('Product size')}: ${product.productSize}` : '',
        `${i18n.t('Quantity')}: ${product.quantity}`,
      ];

      return join(productParts.filter(Boolean), '\n');
    }), '\n\n');
    const relatedArticles = [
      {
        title: 'International H2 and Fuel Cell Vehicle Congress (FCVC) and exhibition 2026',
        date: '01 June 2026',
        description: 'Date event: June 2026 Location: Kunshan, China',
        image: 'https://bekaert.scene7.com/is/image/bekaert/shanghai-article-card-view:Hydrogen-Card-Dynamic-Images-1310',
        link: '/hydrogen-generation/knowledge-center/events/international-hydrogen-and-fuel-cell-vehicle-congress-and-exhibition-2026',
      },
      {
        title: 'Hydrogen Technology World Expo 2026',
        date: '13 February 2026',
        description: 'Date event: 20-22 October 2026 Location: Hamburg, Germany',
        image: 'https://bekaert.scene7.com/is/image/bekaert/iStock-1041150588_Hamburg:Hydrogen-Card-Dynamic-Images-1310',
        link: '/hydrogen-generation/knowledge-center/events/hydrogen-technology-world-expo-2026',
      },
      {
        title: 'World Hydrogen Summit & Exhibition',
        date: '13 February 2026',
        description: 'Date event: 19-21 May 2026 Location: Rotterdam, The Netherlands',
        image: 'https://bekaert.scene7.com/is/image/bekaert/Rotterdam:Hydrogen-Card-Dynamic-Images-1310',
        link: '/hydrogen-generation/knowledge-center/events/world-hydrogen-summit-and-exhibition',
      },
    ];
    const {
      checkMaxCharacters,
      communicationConsent,
      companyInfo,
      contactForm,
      eventCustomlinksInteracted,
      filterCharacters,
      form,
      isOpenNotification,
      isNewsletterSubmitting,
      isRecaptchaEnabled,
      isSubmitDisabled,
      isSubmitSuccess,
      isSubmitting,
      newsletterEmail,
      newsletterMessage,
      newsletterMessageType,
      notification,
      onNewsletterSubmit,
      onRecaptchaExpired,
      onRecaptchaSuccess,
      onSubmit,
      personalInfo,
      recaptchaError,
      recaptchaToken,
      resetForm,
      startNewInquiry,
      submitForm,
      telCheck,
    } = useHydrogenContactForm({
      formName: 'Hydrogen Generation Request a Quote',
      subject: 'Hydrogen generation request a quote',
      dynamicTitle: pageMetaData.value.meta_title,
      leadSubSource,
      maxCharacters: 512,
      getInitialForm: () => ({
        name: '',
        position: 'Request a quote',
        telephone: '',
        email: '',
        company: '',
        comment: '',
      }),
      getInitialCompanyInfo: () => ({
        addressLine1: '',
        country: 'CN',
        city: '',
        postalCode: '',
      }),
      buildComment({ companyInfo, communicationConsent, form, i18n }) {
        const country = getHydrogenCountryLabel(companyInfo.country, i18n.t('China') as string);
        const messageParts = [
          `${i18n.t('Product Information')}:\n${buildProductInformation()}`,
          `${i18n.t('Address Line 1')}: ${companyInfo.addressLine1}`,
          `${i18n.t('Country')}: ${country}`,
          `${i18n.t('City')}: ${companyInfo.city}`,
          `${i18n.t('Postal Code')}: ${companyInfo.postalCode}`,
          `${i18n.t('Marketing updates')}: ${communicationConsent ? i18n.t('Yes') : i18n.t('No')}`,
          `${i18n.t('Your Message')}: ${form.comment}`,
        ];

        return join(messageParts.filter(Boolean), '\n');
      },
      buildSubmissionData({ form }) {
        return {
          telephone: form.telephone || ' ',
        };
      },
      buildHydrogenLeadData() {
        const products = buildHydrogenLeadProducts();

        return products ? { products } : {};
      },
      onReset: resetProductRequests,
    });

    onUpdated(() => {
      document.body.classList.remove('show-hero-img');
    });
    onMounted(() => {
      document.body.classList.remove('show-hero-img');
      breadcrumbs.value = [
        {
          text: i18n.t('Home') as string,
          link: localePath('/'),
        },
        {
          text: i18n.t('Request a quote') as string,
          link: '',
        },
      ];
      pageStore.$patch((state) => {
        state.pageData = assign(state.pageData, {
          pageName: pageTitle,
          pageTitle,
          pageCategory: join(map(breadcrumbs.value, (item) => item.text), '/'),
          breadCrumbs: map(breadcrumbs.value, (item) => item.text),
        });
      });
      eventPageLoad();
    });

    return {
      breadcrumbs,
      checkMaxCharacters,
      communicationConsent,
      companyInfo,
      contactForm,
      eventCustomlinksInteracted,
      filterCharacters,
      form,
      heroImage,
      isOpenNotification,
      isNewsletterSubmitting,
      isRecaptchaEnabled,
      isSubmitDisabled,
      isSubmitSuccess,
      isSubmitting,
      newsletterEmail,
      newsletterMessage,
      newsletterMessageType,
      notification,
      maxProductRequests,
      onNewsletterSubmit,
      onRecaptchaExpired,
      onRecaptchaSuccess,
      onSubmit,
      pageMetaData,
      personalInfo,
      productRequests,
      hydrogenCountryOptions,
      recaptchaError,
      recaptchaToken,
      relatedArticles,
      addProductRequest,
      getMaterialOptions,
      getSurfaceAreaOptions,
      getThicknessOptions,
      getPorosityOptions,
      getProductSizeOptions,
      onProductApplicationChange,
      onProductMaterialChange,
      onProductSurfaceAreaChange,
      onProductThicknessChange,
      onProductPorosityChange,
      removeProductRequest,
      resetForm,
      startNewInquiry,
      submitForm,
      telCheck,
    };
  },
  head() {
    return getMetaInfo(this.pageMetaData);
  },
});
